/* Little Worlds theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { moneyFormat: '${{amount}}', routes: { cart: '/cart' }, strings: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const fmt = (n, d, ts, ds) => {
      ts = ts === undefined ? ',' : ts; ds = ds === undefined ? '.' : ds;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(d);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (parts[1] ? ds + parts[1] : '');
    };
    let v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Overlays (menu, drawer, search) ---------- */
  let lastFocus = null;
  function openOverlay(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('input, button, a'); if (f) setTimeout(() => f.focus(), 60);
  }
  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) { e.preventDefault(); if (target.id === 'CartDrawer') refreshCart(); openOverlay(target); }
    }
    const closer = e.target.closest('[data-close]');
    if (closer) closeOverlay(closer.closest('.drawer, .mobile-menu, .search-modal'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .mobile-menu.is-open, .search-modal.is-open').forEach(closeOverlay);
  });

  /* ---------- Sticky header ---------- */
  const header = $('[data-sticky-header]');
  if (header) {
    const threshold = () => (header.classList.contains('site-header--overlay') ? window.innerHeight * 0.6 : 140);
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > threshold());
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else { $$('.reveal').forEach((el) => el.classList.add('is-in')); }

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) { el.hidden = true; return; }
    const units = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let diff = Math.max(0, target - Date.now());
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      units.d.textContent = pad(d); units.h.textContent = pad(h); units.m.textContent = pad(m); units.s.textContent = pad(s);
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const next = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 0) + (b.dataset.qty === 'plus' ? 1 : -1));
    input.value = next; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  const drawer = $('#CartDrawer');
  function updateCount(count) { $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; }); }
  function sizedImg(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function esc(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    const body = $('[data-cart-body]', drawer), foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = $('#CartEmptyTemplate') ? $('#CartEmptyTemplate').innerHTML : '<p>' + (T.strings.empty || 'Your cart is empty') + '</p>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((it, i) => `
      <div class="line-item">
        <a class="line-item__img" href="${it.url}">${it.image ? `<img src="${sizedImg(it.image, 200)}" alt="${esc(it.product_title)}" width="84" height="84" loading="lazy">` : ''}</a>
        <div>
          <a class="line-item__title" href="${it.url}">${esc(it.product_title)}</a>
          ${it.variant_title && !it.product_has_only_default_variant ? `<div class="line-item__variant">${esc(it.variant_title)}</div>` : ''}
          <div class="qty"><button type="button" data-qty="minus" aria-label="-"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"/></svg></button><input type="number" min="0" value="${it.quantity}" data-line="${i + 1}" aria-label="Quantity"><button type="button" data-qty="plus" aria-label="+"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div>
          <button type="button" class="line-item__remove" data-remove="${i + 1}">Remove</button>
        </div>
        <div class="price">${formatMoney(it.final_line_price)}</div>
      </div>`).join('');
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
    const bar = $('[data-ship-bar]', drawer);
    if (bar) {
      const goal = parseFloat(bar.dataset.goal) * 100 * (window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate || 1) : 1);
      const left = goal - cart.total_price;
      $('[data-ship-fill]', bar).style.width = Math.min(100, (cart.total_price / goal) * 100) + '%';
      $('[data-ship-text]', bar).innerHTML = left > 0 ? `You're <strong>${formatMoney(left)}</strong> away from free shipping ✦` : 'Yay! Your order ships free ✦';
    }
  }
  function refreshCart() { return fetch('/cart.js').then((r) => r.json()).then(renderCart).catch(() => {}); }
  function changeLine(line, quantity) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) })
      .then((r) => r.json()).then((cart) => { renderCart(cart); if (document.body.classList.contains('template-cart')) location.reload(); });
  }
  if (drawer) {
    drawer.addEventListener('change', (e) => { if (e.target.dataset.line) changeLine(parseInt(e.target.dataset.line, 10), parseInt(e.target.value, 10) || 0); });
    drawer.addEventListener('click', (e) => { const r = e.target.closest('[data-remove]'); if (r) changeLine(parseInt(r.dataset.remove, 10), 0); });
  }
  function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.innerHTML; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then((r) => r.json().then((j) => { if (!r.ok) throw j; return j; }))
      .then(() => refreshCart())
      .then(() => {
        // Keep shoppers browsing: the floating cart bar confirms the add.
        // The full cart drawer only opens when they ask for it (View cart / cart icon).
        if (document.getElementById('CartBar')) document.dispatchEvent(new CustomEvent('cart:added'));
        else toast(T.strings.added || 'Added to cart');
      })
      .catch((err) => toast((err && (err.description || err.message)) || 'Could not add to cart'))
      .finally(() => { if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label; } });
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    if (q.dataset.quickAdd === 'placeholder') { toast('Add real products in Shopify admin to sell this ✦'); return; }
    addToCart([{ id: parseInt(q.dataset.quickAdd, 10), quantity: 1 }], q);
  });
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      if (!drawer) return;
      e.preventDefault();
      const id = parseInt(form.querySelector('[name="id"]').value, 10);
      const qty = parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1;
      addToCart([{ id, quantity: qty }], form.querySelector('[type="submit"]'));
    });
  });
  $$('[data-cart-page] input[data-line]').forEach((inp) => inp.addEventListener('change', () => changeLine(parseInt(inp.dataset.line, 10), parseInt(inp.value, 10) || 0)));

  /* ---------- Product: variants + gallery ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('[data-product-json]', root);
    const product = dataEl ? JSON.parse(dataEl.textContent) : null;
    const main = $('[data-main-image]', root);
    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => {
      $$('[data-thumb]', root).forEach((x) => x.classList.remove('is-active')); t.classList.add('is-active');
      main.src = t.dataset.thumb; main.srcset = '';
    }));
    if (!product) return;
    const idInput = $('[name="id"]', root), price = $('[data-price]', root), btn = $('[data-add-button]', root);
    const current = () => $$('[data-option-index]', root).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    function update() {
      const opts = current();
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('[data-option-index]', root).forEach((fs) => { const sel = fs.querySelector('input:checked'); const s = fs.querySelector('legend span'); if (s && sel) s.textContent = sel.value; });
      if (!v) { btn.disabled = true; return; }
      idInput.value = v.id;
      price.innerHTML = (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price)}</s>` : '') + formatMoney(v.price);
      price.classList.toggle('price--sale', v.compare_at_price > v.price);
      btn.disabled = !v.available;
      btn.querySelector('span').textContent = v.available ? btn.dataset.addText : (T.strings.soldOut || 'Sold out');
      if (v.featured_image && main) { main.src = sizedImg(v.featured_image.src, 1100); main.srcset = ''; }
      $$('[data-scale]', root).forEach((el) => el.classList.toggle('is-current', opts.includes(el.dataset.scale)));
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(); });
    const sticky = $('[data-sticky-atc]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(btn);
      $('button', sticky).addEventListener('click', () => btn.click());
    }
  });

  /* ---------- Predictive search ---------- */
  const sInput = $('[data-predictive-input]');
  const sOut = $('[data-predictive-results]');
  if (sInput && sOut) {
    let t;
    sInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = sInput.value.trim();
      if (q.length < 2) { sOut.innerHTML = ''; return; }
      t = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
          .then((r) => r.json())
          .then((d) => {
            const items = (d.resources && d.resources.results && d.resources.results.products) || [];
            sOut.innerHTML = items.map((p) => `<a href="${p.url}">${p.image ? `<img src="${sizedImg(p.image, 120)}" alt="" width="52" height="52">` : ''}<span><strong>${esc(p.title)}</strong><br><span class="muted">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('') || '<p class="muted">No stickers found — try "cat" or "mini".</p>';
          }).catch(() => {});
      }, 220);
    });
  }

  /* ---------- Collection: filter toggle + sort ---------- */
  const ft = $('[data-filter-toggle]');
  if (ft) ft.addEventListener('click', () => $('.filters').classList.toggle('is-open'));
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));
  $$('[data-auto-submit]').forEach((f) => f.addEventListener('change', () => f.submit()));
})();
